import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { RootNavigationComponent } from './root-nav/root-nav.component';
import { ListNavigationComponent } from './list-nav/list-nav.component';
import { SidebarModule } from 'ng-sidebar';
import { HeaderComponent } from './components/header/header.component';

@NgModule({
  declarations: [
    RootNavigationComponent,
    ListNavigationComponent,
    HeaderComponent,
  ],
  imports: [
    CommonModule,
    RouterModule,
    SidebarModule
  ],
  exports: [
    ListNavigationComponent,
    HeaderComponent
  ]
})
export class NavigationModule { }
